function isPageReload() {
  const wasReloaded = sessionStorage.getItem("isReload");
  const navType =
    performance.getEntriesByType?.("navigation")[0]?.type ??
    performance.navigation?.type;

  return Boolean(
    wasReloaded && (navType === "reload" || navType === 1)
  );
}

export { isPageReload };
